import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba0e156"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "名称",
        name: "name",
        rules: _ctx.rules.name
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
            placeholder: "请输入"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, {
        ref: "organization_id",
        label: "所属组织",
        name: "organization_id",
        rules: [{required: true, message: '请选择'}]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_cascader, {
            value: _ctx.formState.organization_id,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.organization_id) = $event)),
            changeOnSelect: true,
            placeholder: "请选择",
            "field-names": { label: 'name', value: 'id', children: 'children' },
            options: _ctx.list
          }, null, 8, ["value", "options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "level",
        label: "所属等级",
        name: "level",
        rules: _ctx.rules.level
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.formState.level,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.level) = $event)),
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleLevels, (item) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: item,
                  value: item
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["rules"]),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "label-col", "wrapper-col"]))
}